var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "panel-footer text-center" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "form",
                  {
                    attrs: { method: "get", action: _vm.excelTemplateFilePath },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button btn btn-default",
                        attrs: { type: "submit" },
                      },
                      [
                        _vm._v(
                          "\n                                    Download Template\n                                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "form",
                  {
                    attrs: { method: "get", action: _vm.excelExampleFilePath },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button btn btn-default",
                        attrs: { type: "submit" },
                      },
                      [
                        _vm._v(
                          "\n                                    Download Example\n                                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "panel-footer text-center" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "form",
                  { attrs: { method: "get", action: _vm.csvTemplateFilePath } },
                  [
                    _c("button", { staticClass: "button btn btn-default" }, [
                      _vm._v(
                        "\n                                    Download Template\n                                "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "form",
                  { attrs: { method: "get", action: _vm.csvExampleFilePath } },
                  [
                    _c("button", { staticClass: "button btn btn-default" }, [
                      _vm._v(
                        "\n                                    Download Example\n                                "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(2),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-body text-center" }, [
      _c("p", { staticClass: "fa-2x" }, [
        _vm._v("\n                        Excel\n                    "),
      ]),
      _vm._v(" "),
      _c("i", {
        staticClass: "fad fa-file-excel fa-5x aristotle-font-awesome-duotone",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-body text-center" }, [
      _c("p", { staticClass: "fa-2x" }, [
        _vm._v("\n                        CSV\n                    "),
      ]),
      _vm._v(" "),
      _c("i", {
        staticClass: "fad fa-file-csv fa-5x aristotle-font-awesome-duotone",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _vm._v("\n        Learn more and see examples on the\n        "),
      _c(
        "a",
        { attrs: { href: "https://labs.aristotlemetadata.com/#/sddf" } },
        [
          _vm._v(
            "\n            Simple Data Dictionary Format\n            specification page.\n        "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }